
import { useState } from 'react';
import { Send, FileText } from 'lucide-react';
import WhatsAppNotificationsPage from '../../pages/WhatsAppNotificationsPage';
import CampaignsPage from '../../pages/CampaignsPage';

interface ManualNotificationsDashboardProps {
    gymId: string;
}

type ManualSubTab = 'setup' | 'logs';

const ManualNotificationsDashboard = ({ gymId }: ManualNotificationsDashboardProps) => {
    const [activeSubTab, setActiveSubTab] = useState<ManualSubTab>('setup');

    const subTabs: { id: ManualSubTab; name: string; icon: typeof Send }[] = [
        { id: 'setup', name: 'Setup Campaigns', icon: Send },
        { id: 'logs', name: 'Campaigns & Logs', icon: FileText }
    ];

    return (
        <div className="space-y-6">
            {/* Sub-Tabs */}
            <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-lg w-fit">
                {subTabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveSubTab(tab.id)}
                            className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all ${activeSubTab === tab.id
                                ? 'bg-white text-blue-600 shadow-sm'
                                : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            <Icon className="h-4 w-4" />
                            {tab.name}
                        </button>
                    );
                })}
            </div>

            {activeSubTab === 'setup' ? (
                <WhatsAppNotificationsPage gymId={gymId} hideHeader />
            ) : (
                <CampaignsPage gymId={gymId} hideHeader />
            )}
        </div>
    );
};

export default ManualNotificationsDashboard;
